<template>
    <div>
        <pdf v-for="i in numPages" :key="i" :src="pdfUrl" :page="i">
        </pdf>
    </div>
</template>

<script>
import pdf from 'vue-pdf'
import { getQueryTemp } from '../api/forms';
import { Notify, Dialog } from 'vant';
export default {
    components: { pdf },
    data() {
        return {
            numPages: 1, // pdf文件总页数
            src: '', // pdf文件地址
            pdfUrl: null,
            articleType: this.$route.query.articleType || "",
            pay: this.$route.query.pay || "",
        }
    },
    mounted() {
        this.QueryTemp()
    },
    methods: {
        QueryTemp() {
            let data = {
                // articleType: this.articleType,
                // pay: this.pay,
                articleType: 2,
                pay: 1
            }
            getQueryTemp(data).then((res) => {
                if (res.code == 200) {
                    this.src = res.data.url
                    this.pdfTask(this.src)
                }
                else {
                    Notify({ type: 'warning', message: res.msg, duration: 6000 });
                }
            })
        },


        pdfTask(src) {
            var self = this
            var loadingTask = pdf.createLoadingTask(src)
            loadingTask.promise.then(pdf => {
                self.pdfUrl = loadingTask
                self.numPages = pdf.numPages
            }).catch((err) => {
                console.error('pdf加载失败')
            })
        }
    }
}

</script>